var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['status', { [_vm.type]: _vm.type }]},[_vm._v(_vm._s(_vm.status.name || ""))])
}
var staticRenderFns = []

export { render, staticRenderFns }